import axios from 'axios';
import { api_labelflow } from "../../../../config.jsx";

export const getSignup = async (params) => {
    try {
        const response = await axios.post(
            `${api_labelflow}/auth_management/signup`,
            params,
            {
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );
        return response?.data || null;
    } catch (error) {
        console.error('Error during signup:', error);
        throw error;
    }
};

